import React, { useEffect, useState } from 'react'
import { Box, Card, CardContent, Divider, Typography } from '@material-ui/core'
import FieldInfoNG from 'asterX-UI/DataDisplay/FieldInfoNG'
import { NotFound } from 'components/NotFound/NotFound'
import { AsterChip } from 'asterX-UI/Chip'
import { INFO_COLORS } from 'asterX-UI'
import { useAuthStore } from 'context/AuthStore'
import { useStyles } from './pledge-card.styles'

const getCollateralTypeName = typeId => {
  switch (typeId) {
    case 101754:
      return 'Недвижимость'
    case 101760:
      return 'Под залог недвижимости'
    case 101762:
      return 'На покупку автомобиля'
    case 101757:
      return 'На покупку авто'
    case 101753:
      return 'автомобиль'
    default:
      return typeId
  }
}

export const PledgeCard = ({ sections, columns = '5', contract }) => {
  const classes = useStyles()

  const { authStore } = useAuthStore()
  const [currentColumns, setCurrentColumns] = useState(authStore.isMobile ? '1' : columns)

  useEffect(() => {
    if (authStore.isMobile) {
      setCurrentColumns('1')
    } else {
      setCurrentColumns(columns)
    }
  }, [authStore.isMobile, columns])

  return (
    <>
      <Card variant="outlined" className={classes.card}>
        <CardContent className={classes.cardContent}>
          <Box display="grid" gridTemplateColumns={`repeat(${currentColumns}, 1fr)`} gap={4}>
            {sections ? (
              sections.map((section, sectionIndex) => (
                <React.Fragment key={sectionIndex}>
                  {section.title && (
                    <Box gridColumn={`span ${currentColumns}`} className={classes.chipContainer}>
                      <Box style={{ display: 'flex', alignItems: 'center', flexGrow: 1, gap: 8 }}>
                        <Typography className={classes.title}>{section.title}</Typography>
                        {section.hasChip && (
                          <AsterChip
                            label={getCollateralTypeName(contract?.collateralTypeId || 'нет залога')}
                            style={{
                              border: `1px solid ${INFO_COLORS[400]}`,
                              backgroundColor: INFO_COLORS[50],
                              color: INFO_COLORS[700]
                            }}
                          />
                        )}
                      </Box>
                      {section.hasChip && (
                        <Box className={classes.hasChip}>
                          <Box className={classes.chipBox}>
                            <Typography className={classes.chipTitle}>Залог</Typography>
                            <Box className={classes.childChipBox}>
                              <Typography className={classes.childChipText}>{`${
                                contract?.collateralName || 'нет залога'
                              } ->`}</Typography>
                            </Box>
                          </Box>
                          <Box className={classes.chipBox}>
                            <Typography className={classes.chipTitle}>Залогодатель</Typography>
                            <Box className={classes.childChipBox}>
                              <Typography className={classes.childChipText}>{`${
                                contract?.depositorFullName || 'нет залога'
                              } ->`}</Typography>
                            </Box>
                          </Box>
                        </Box>
                      )}
                    </Box>
                  )}
                  {section.data.map((item, index) => (
                    <React.Fragment key={index}>
                      <Box className={classes.boxItem}>
                        <FieldInfoNG label={item.label} isVertical>
                          <Typography className={classes.description}>{item.value}</Typography>
                        </FieldInfoNG>
                      </Box>
                    </React.Fragment>
                  ))}
                  {section.line && sectionIndex !== sections.length - 1 && (
                    <Box gridColumn={`span ${currentColumns}`} className={classes.divider}>
                      <Divider />
                    </Box>
                  )}
                </React.Fragment>
              ))
            ) : (
              <NotFound />
            )}
          </Box>
        </CardContent>
      </Card>
    </>
  )
}
